module.exports = __webpack_public_path__ + "img/508.79d3b676.png";